import { jsx as i, jsxs as T, Fragment as A } from "react/jsx-runtime";
import { createElement as b, useRef as N, useState as k, useEffect as h, createContext as R, useContext as j } from "react";
import { withManagedProps as w } from "@made-people/managed-props";
import { withZod as y } from "@made-people/react-prop-guard";
import { textBlockBlueprint as g } from "./index-blueprint.es.js";
import { ButtonAsLink as O, buttonAsLinkSchema as H } from "@made-people/blueprint-button";
import { z as r } from "zod";
import { componentWrapperLayoutSchema as W, componentWrapperSchema as z, ComponentWrapper as _ } from "@made-people/blueprint-component-wrapper";
import { useTranslate as I } from "@made-people/grease-translations";
import { Markdown as E } from "@made-people/blueprint-markdown";
import { LinkAsLink as F, linkAsLinkSchema as M } from "@made-people/blueprint-link";
import { Heading as P, headingSchema as Z } from "@made-people/blueprint-heading";
import $ from "clsx";
import "@made-people/blueprint";
const q = () => {
  const { enableTruncate: e, isTruncated: t, setIsTruncated: n, shouldTruncate: o, slots: l } = p(), s = I();
  if (!e || !o)
    return null;
  const a = s(t ? "Text_Block_Read_More" : "Text_Block_Read_Less");
  return /* @__PURE__ */ i(
    "button",
    {
      className: l.truncateButton,
      onClick: () => n(!t),
      children: a
    }
  );
}, x = () => {
  const { body: e, slots: t, contentRef: n, truncateStyleObject: o } = p();
  return !e || e === "<p> </p>" ? null : /* @__PURE__ */ T(A, { children: [
    /* @__PURE__ */ i("div", { className: t.body, ref: n, style: o, children: /* @__PURE__ */ i(E, { content: e }) }),
    /* @__PURE__ */ i(q, {})
  ] });
}, B = () => {
  const { slots: e, ctas: t } = p();
  return t != null && t.length ? /* @__PURE__ */ i("div", { className: e.ctaWrapper, children: t.map((n, o) => {
    if (n.component === "ButtonAsLink")
      return /* @__PURE__ */ b(O, { ...n, key: o });
    if (n.component === "LinkAsLink")
      return /* @__PURE__ */ b(F, { ...n, key: o });
  }) }) : null;
}, S = () => {
  var n;
  const { slots: e, heading: t } = p();
  return !t || !t.lead && !((n = t.badge) != null && n.label) && !t.heading && !t.eyebrow ? null : /* @__PURE__ */ i(P, { className: e.headingWrapper, ...t });
}, D = (e, t) => {
  const n = N(null), [o, l] = k(!0), [s, a] = k(!0), m = () => {
    if (typeof t == "number" && n.current) {
      const c = n.current, d = window.getComputedStyle(c);
      let u = parseFloat(d.lineHeight);
      isNaN(u) && (u = parseFloat(d.fontSize) * 1.2);
      const f = u * t;
      l(c.scrollHeight > f);
    }
  };
  return h(() => {
    m();
  }, [e, t]), h(() => {
    a(!0);
  }, [e, t, o]), h(() => {
    if (!n.current)
      return;
    const c = new ResizeObserver(() => {
      m();
    });
    return c.observe(n.current), () => {
      c.disconnect();
    };
  }, [e, t]), {
    ref: n,
    shouldTruncate: o,
    isTruncated: o ? s : !1,
    setIsTruncated: a,
    truncateStyleObject: {
      display: "-webkit-box",
      WebkitLineClamp: s ? t : void 0,
      WebkitBoxOrient: "vertical",
      overflow: "hidden"
    }
  };
}, v = r.object({
  layout: W.optional(),
  variants: r.custom().optional(),
  alignContent: r.enum(["left", "center", "right"]).optional(),
  heading: Z.optional(),
  body: r.string().optional(),
  ctas: r.array(
    H.extend({
      component: r.literal("ButtonAsLink").optional()
    }).or(
      M.extend({
        component: r.literal("LinkAsLink").optional()
      })
    )
  ).optional(),
  scrollToId: r.string().optional(),
  id: r.string().optional(),
  enableTruncate: r.boolean().optional(),
  truncateRows: r.number().optional(),
  visibility: z.shape.visibility.optional(),
  className: r.string().optional(),
  children: r.custom().optional()
}), L = R(null), p = () => {
  const e = j(L);
  if (!e)
    throw new Error("TextBlock components must be used within TextBlock");
  return e;
}, G = y(v, (e) => {
  const t = g.styles(e.variants);
  return /* @__PURE__ */ i(C, { ...e, children: /* @__PURE__ */ T(
    _,
    {
      layout: { ...e.layout },
      visibility: e.visibility,
      className: $(t.base, e.className),
      id: e.id,
      children: [
        /* @__PURE__ */ i(S, {}),
        /* @__PURE__ */ i(x, {}),
        /* @__PURE__ */ i(B, {})
      ]
    }
  ) });
}), C = y(
  v,
  ({
    variants: e,
    scrollToId: t,
    children: n,
    enableTruncate: o,
    truncateRows: l,
    ...s
  }) => {
    const a = g.styles(e), {
      shouldTruncate: m,
      ref: c,
      isTruncated: d,
      setIsTruncated: u,
      truncateStyleObject: f
    } = D(s.body, l ?? 2);
    return /* @__PURE__ */ i(
      L.Provider,
      {
        value: {
          ...s,
          slots: a,
          isTruncated: d,
          contentRef: c,
          setIsTruncated: u,
          truncateRows: l ?? 2,
          enableTruncate: o,
          shouldTruncate: m,
          scrollToId: t,
          truncateStyleObject: o ? f : {}
        },
        children: n
      }
    );
  }
), lt = Object.assign(
  w("TextBlock", G),
  {
    Heading: S,
    Body: x,
    Ctas: B,
    Root: C
  }
);
export {
  x as Body,
  B as CallToActions,
  S as Heading,
  lt as TextBlock,
  q as TruncateButton,
  v as textBlockSchema,
  p as useTextBlockContext,
  D as useTruncate
};
//# sourceMappingURL=index.es.js.map
